import { render, staticRenderFns } from "./tag-import-modal.vue?vue&type=template&id=f1b091f2&scoped=true&"
import script from "./tag-import-modal.vue?vue&type=script&lang=js&"
export * from "./tag-import-modal.vue?vue&type=script&lang=js&"
import style0 from "./tag-import-modal.vue?vue&type=style&index=0&id=f1b091f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1b091f2",
  null
  
)

export default component.exports